"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLogDetails = void 0;
exports.ChangeLogDetails = ['created', 'updated', 'deleted'];
